<rotec-tab-group class="tab-group" tabsHeight="middle">
  <rotec-tab title="Settings" class="tab">
    <rc-template-toolbox-category-settings [config]="config" (settings)="settingsChanged($event)">
    </rc-template-toolbox-category-settings>
  </rotec-tab>
  <rotec-tab title="Content" class="tab">
    <rotec-accordion [accordions]="accordions">
      <ng-template id="logo">
        <rc-template-toolbox-category
          [isLogo]="true"
          [useCustomListItemHeight]="true"
          [fieldDefinitions$]="
            categorizedFieldDefinitions$
              | templateToolboxItemFilter: ReportTemplateFieldCategory.Logo
          "
        >
        </rc-template-toolbox-category>
      </ng-template>

      <ng-template id="header">
        <rc-template-toolbox-category
          [fieldDefinitions$]="
            categorizedFieldDefinitions$
              | templateToolboxItemFilter: ReportTemplateFieldCategory.HeaderData
          "
        >
        </rc-template-toolbox-category>
      </ng-template>

      <ng-template id="typeData">
        <rc-template-toolbox-category
          [fieldDefinitions$]="
            categorizedFieldDefinitions$
              | templateToolboxItemFilter: ReportTemplateFieldCategory.TypeData
          "
        >
        </rc-template-toolbox-category>
      </ng-template>

      <ng-template id="measurement">
        <rc-template-toolbox-category
          [fieldDefinitions$]="
            categorizedFieldDefinitions$
              | templateToolboxItemFilter: ReportTemplateFieldCategory.MeasurementData
          "
        >
        </rc-template-toolbox-category>
      </ng-template>

      <ng-template id="freeTextfield">
        <rc-template-toolbox-category-freetext [(userDefinedFields)]="userDefinedFields">
        </rc-template-toolbox-category-freetext>
      </ng-template>
    </rotec-accordion>
  </rotec-tab>
</rotec-tab-group>
